<template>
  <svg v-bind="attrs">
    <path
      d="M8.00977 3V0L4.00977 4L8.00977 8V5C11.3198 5 14.0098 7.69 14.0098 11C14.0098 12.01 13.7598 12.97 13.3098 13.8L14.7698 15.26C15.58 13.9869 16.0102 12.5091 16.0098 11C16.0098 6.58 12.4298 3 8.00977 3ZM8.00977 17C4.69977 17 2.00977 14.31 2.00977 11C2.00977 9.99 2.25977 9.03 2.70977 8.2L1.24977 6.74C0.439518 8.01309 0.00934601 9.49094 0.00976593 11C0.00976593 15.42 3.58977 19 8.00977 19V22L12.0098 18L8.00977 14V17Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconAttributes } from '@/utils/icons';

const attrs = iconAttributes({ width: 16, height: 22 });
</script>
